import React from 'react';
import { Link, GatsbyLinkProps } from 'gatsby';

import type { TConstantPaths } from '@hooks';

interface IConstLink
  extends Omit<GatsbyLinkProps<Record<string, unknown>>, 'ref'> {
  to: TConstantPaths;
}

/** Guarantee your path is correct using this thin wrapper. */
const ConstLink = ({ to, children, ...rest }: IConstLink) => (
  <Link to={to} {...rest}>
    {children}
  </Link>
);

export { ConstLink };
